import { useEffect, useState } from "react";
import { Progress } from "@/components/ui/progress";

interface LoadingBarProps {
  totalTime: number;
  timeoutDuration: number;
  updateInterval: number;
  onOvertime: () => void;
  onTimeout: () => void;
}

export function LoadingBar({ 
  totalTime, 
  timeoutDuration,
  updateInterval, 
  onOvertime,
  onTimeout 
}: LoadingBarProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    let progressValue = 0;
    let hasTriggeredOvertime = false;
    let hasTriggeredTimeout = false;
    
    const progressInterval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      
      // Check for timeout first
      if (elapsed >= timeoutDuration && !hasTriggeredTimeout) {
        hasTriggeredTimeout = true;
        onTimeout();
        clearInterval(progressInterval);
        return;
      }
      
      // Calculate progress based on total time
      progressValue = Math.min((elapsed / totalTime) * 100, 100);
      setProgress(progressValue);
      
      // Trigger overtime if we've reached total time but not timeout
      if (elapsed >= totalTime && !hasTriggeredOvertime) {
        hasTriggeredOvertime = true;
        onOvertime();
      }
    }, updateInterval);

    return () => {
      clearInterval(progressInterval);
    };
  }, [totalTime, timeoutDuration, updateInterval, onOvertime, onTimeout]);

  return (
    <div className="space-y-6">
      <Progress 
        value={progress} 
        className="h-4 bg-blue-100 rounded-full overflow-hidden"
        indicatorClassName="bg-gradient-to-r from-blue-500 to-blue-600 animate-pulse"
      />
      <p className="text-xl text-center text-gray-600 font-medium">
        {Math.round(progress)}% completo
      </p>
    </div>
  );
}